import InvoiceContainer from "./InvoiceContainer";

export default InvoiceContainer;
